import { useEffect, useMemo, useState } from "react";
import { GlobalAuthFetch } from "../../Utils/GlobalAuthFetch/GlobalAuthFetch";

export const useTechnicians = (leaderUuid) => {
  const [allTechnicians, setAllTechnicians] = useState([]);

  useEffect(() => {
    const fetchTechnicians = async () => {
      const techniciansPayload = await GlobalAuthFetch({
        path: "/worker/technicians/all",
      });

      if (techniciansPayload?.payload?.status === 200) {
        const { data } = techniciansPayload.payload;

        setAllTechnicians(
          data.map((e) => ({
            value: e.uuid,
            name: `${e.firstName || ""} ${e.lastName || ""}`,
            uuid: e.uuid,
          })),
        );
      }
    };

    fetchTechnicians();
  }, []);

  const techniciansWithoutLeader = useMemo(
    () => allTechnicians.filter((t) => t.uuid !== leaderUuid),
    [allTechnicians, leaderUuid],
  );

  return {
    allTechnicians,
    techniciansWithoutLeader,
  };
};
